<template>
  <el-upload
    action="#"
    class="upload xls21ds"
    drag
    v-bind="$attrs"
    :style="{ '--upload-trigger-height': height }"
  >
    <slot name="icon">
      <div>
        <img class="icon" src="@/assets/images/enclosure.png" />
      </div>
    </slot>
    <slot name="text">
      <div>将文件拖到此处，或<em>点击上传</em></div>
    </slot>
    <slot name="tip"> <div>只能上传jpg/png文件，且不超过500kb</div> </slot>
  </el-upload>
</template>
<script>
export default {
  props: {
    /**
     * trigger 高度 Number | String
     */
    height: {
      type: String,
      default: '120px'
    }
  }
}
</script>
<style lang="scss">
.upload.xls21ds {
  display: flex;
  .el-upload {
    width: 100%;
    .el-upload-dragger {
      border: 1px dashed #0177ae;
      width: 100%;
      height: var(--upload-trigger-height, 120px);
      background-color: rgba(0, 164, 240, 0.1);
    }
  }
  &[disabled] .el-upload .el-upload-dragger {
    cursor: not-allowed;
  }
}
</style>
<style lang="scss" scoped>
.icon {
  margin-top: 27px;
  margin-bottom: 7px;
  width: 56px;
  height: 34px;
}
</style>
